import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { Save, CheckCircle, AlertCircle } from 'lucide-react';

const PRICE_FIELDS = [
  { key: 'price_bw',    label: 'Ч/Б печать одна сторона',   placeholder: '500'  },
  { key: 'price_color', label: 'Ч/Б печать двухсторон',     placeholder: '1500' },
  { key: 'price_scan',  label: 'Сканирование одна сторона', placeholder: '500'  },
  { key: 'price_copy',  label: 'Сканирование двухсторон',   placeholder: '500'  },
];

export const Settings = () => {
  const { fetchAuthorized } = useAuth();
  const [prices, setPrices]   = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [status, setStatus]   = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await fetchAuthorized('/api/dashboard/settings/prices');
      const d   = await res.json();
      if (d.success) setPrices(d.prices);
    } catch {}
    finally { setLoading(false); }
  }, [fetchAuthorized]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setStatus(null);
    try {
      const res = await fetchAuthorized('/api/dashboard/settings/prices', {
        method: 'POST', body: JSON.stringify(prices),
      });
      setStatus(res.ok
        ? { ok: true,  text: 'Сохранено. Новые цены применятся к следующим заказам.' }
        : { ok: false, text: 'Ошибка при сохранении' }
      );
    } catch {
      setStatus({ ok: false, text: 'Ошибка соединения' });
    } finally {
      setSaving(false);
      setTimeout(() => setStatus(null), 5000);
    }
  };

  useEffect(() => { load(); }, [load]);

  if (loading) {
    return (
      <div className="fade-in">
        <div className="page-header"><div><h1>Настройки</h1><p>Цены и параметры сети</p></div></div>
        <p className="text-dim" style={{ fontSize: '13px' }}>Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="fade-in">
      <div className="page-header">
        <div>
          <h1>Настройки</h1>
          <p>Цены и параметры сети</p>
        </div>
      </div>

      <div className="card" style={{ maxWidth: '800px', padding: '28px' }}>
        <p className="section-title" style={{ marginBottom: '18px' }}>Цены (UZS за 1 единицу)</p>

        <form onSubmit={save}>
          <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginBottom: '20px' }}>
            {PRICE_FIELDS.map(({ key, label, placeholder }) => (
              <div key={key} className="field" style={{ flex: '1 1 180px' }}>
                <label className="field-label">{label}</label>
                <div className="field-wrap">
                  <input
                    type="number"
                    min="0"
                    value={prices[key] || ''}
                    onChange={e => setPrices({ ...prices, [key]: e.target.value })}
                    placeholder={placeholder}
                    style={{ paddingRight: '44px' }}
                  />
                  <span className="field-suffix">UZS</span>
                </div>
              </div>
            ))}
          </div>

          {status && (
            <div className={`alert ${status.ok ? 'alert-success' : 'alert-error'}`} style={{ marginBottom: '14px' }}>
              {status.ok
                ? <CheckCircle size={14} style={{ flexShrink: 0 }} />
                : <AlertCircle size={14} style={{ flexShrink: 0 }} />
              }
              <span>{status.text}</span>
            </div>
          )}

          <button type="submit" disabled={saving} className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '10px' }}>
            <Save size={14} />
            {saving ? 'Сохранение...' : '💾 Сохранить цены'}
          </button>
        </form>
      </div>
    </div>
  );
};
